import {
  ConfigProvider,
  Descriptions,
  Tag,
  Button,
  Flex,
  Typography,
  Checkbox,
  Space,
  Switch,
} from "antd";

import EmployeeProfile from "@/components/cards/EmployeeProfile";

import PlusIcon from "@/icons/PlusIcon";
import ExclamationCircleIcon from "@/icons/ExclamationCircleIcon";

import { formateISODateToMoment, formateDate } from "@/utils";

import { PRIORITY_OPTIONS, TASK_TYPE_OPTIONS } from "@/constants/tasks";

const InfoSection = ({
  data,
  priority,
  taskType,
  is_overdue,
  isUserCanEditTemplate,
  handleEditTask,
  setIsGroupTask,
  showSetMeExecutor,
  showSetMeAcceptor,
  setMeExecutor,
  setMeAcceptor,
  handleUpdateVisibleItem,
}) => {
  const getPriorityIcon = (color) => {
    return PRIORITY_OPTIONS.find((item) => item.value === color)?.icon;
  };
  const getTaskTypeIcon = (color) => {
    return TASK_TYPE_OPTIONS.find((item) => item.value === color)?.icon;
  };

  const handleGroupTaskChange = async (e) => {
    await setIsGroupTask(e.target.checked);
  };

  return (
    <Flex vertical gap={15}>
      <ConfigProvider
        theme={{
          components: {
            Descriptions: {
              itemPaddingBottom: 10,
            },
          },
        }}
      >
        <Descriptions
          column={1}
          colon={false}
          styles={{
            label: {
              width: 130,
            },
          }}
        >
          <Descriptions.Item label="Тип задачи:">
            {taskType && (
              <Tag
                icon={getTaskTypeIcon(taskType.key)}
                color={taskType.color}
                className="tag-with-icon lg"
              >
                {taskType.name}
              </Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Автор:">
            <EmployeeProfile
              {...data.author}
              fullName={false}
              avatarSize={24}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Исполнитель:">
            <Flex vertical gap={5} align="flex-start">
              {!!data.executor ? (
                <EmployeeProfile
                  {...data.executor}
                  fullName={false}
                  avatarSize={24}
                />
              ) : isUserCanEditTemplate ? (
                <Button
                  color="default"
                  variant="link"
                  size="small"
                  type="text"
                  icon={<PlusIcon />}
                  onClick={handleEditTask}
                  style={{ paddingInline: 0 }}
                >
                  Назначить
                </Button>
              ) : (
                "-"
              )}

              {showSetMeExecutor && (
                <Typography.Link
                  onClick={setMeExecutor}
                  style={{ fontSize: "12px" }}
                >
                  Назначить на меня
                </Typography.Link>
              )}
            </Flex>
          </Descriptions.Item>

          <Descriptions.Item label="Приемщик:">
            <Flex vertical gap={5} align="flex-start">
              {!!data.assignee_acceptor ? (
                <EmployeeProfile
                  {...data.assignee_acceptor}
                  fullName={false}
                  avatarSize={24}
                />
              ) : isUserCanEditTemplate ? (
                <Button
                  color="default"
                  variant="link"
                  size="small"
                  type="text"
                  icon={<PlusIcon />}
                  onClick={handleEditTask}
                  style={{ paddingInline: 0 }}
                >
                  Назначить
                </Button>
              ) : (
                "-"
              )}

              {showSetMeAcceptor && (
                <Typography.Link
                  onClick={setMeAcceptor}
                  style={{ fontSize: "12px" }}
                >
                  Назначить на меня
                </Typography.Link>
              )}
            </Flex>
          </Descriptions.Item>

          <Descriptions.Item label="Приоритет:">
            {priority && (
              <Tag
                icon={getPriorityIcon(priority.color)}
                className="tag-with-icon"
              >
                {priority.name}
              </Tag>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Дата начала:">
            {!!data.start_date ? (
              formateDate(data.start_date)
            ) : isUserCanEditTemplate ? (
              <Button
                color="default"
                variant="link"
                size="small"
                type="text"
                icon={<PlusIcon />}
                onClick={handleEditTask}
                style={{ paddingInline: 0 }}
              >
                Назначить
              </Button>
            ) : (
              "-"
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Срок исполнения:">
            {!!data.due_date ? (
              <Flex align="center" gap={4}>
                {is_overdue && (
                  <ExclamationCircleIcon
                    style={{ fontSize: 14, color: "#E66A25" }}
                  />
                )}
                <span>{formateISODateToMoment(data.due_date)}</span>
              </Flex>
            ) : isUserCanEditTemplate ? (
              <Button
                color="default"
                variant="link"
                size="small"
                type="text"
                icon={<PlusIcon />}
                onClick={handleEditTask}
                style={{ paddingInline: 0 }}
              >
                Назначить
              </Button>
            ) : (
              "-"
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Рабочая группа:">
            {data.unit?.name || "-"}
          </Descriptions.Item>

          <Descriptions.Item label="Соисполнители:">
            {!!data.coexecutors?.length ? (
              <Flex vertical gap={5}>
                {data.coexecutors.map((executor) => (
                  <EmployeeProfile
                    {...executor}
                    key={executor.uuid}
                    fullName={false}
                    avatarSize={24}
                  />
                ))}
              </Flex>
            ) : isUserCanEditTemplate ? (
              <Button
                color="default"
                variant="link"
                size="small"
                type="text"
                icon={<PlusIcon />}
                onClick={handleEditTask}
                style={{ paddingInline: 0 }}
              >
                Назначить
              </Button>
            ) : (
              "-"
            )}
          </Descriptions.Item>
        </Descriptions>
      </ConfigProvider>

      {isUserCanEditTemplate && (
        <Checkbox
          disabled={data.readOnly || !isUserCanEditTemplate}
          checked={data.is_accessible_for_all_in_unit}
          onChange={handleGroupTaskChange}
        >
          Уведомлять всех в рабочей группе
        </Checkbox>
      )}

      {isUserCanEditTemplate && (
        <Space style={!isUserCanEditTemplate ? { opacity: "0.25" } : {}}>
          <Switch
            disabled={!isUserCanEditTemplate}
            defaultValue={data.is_visible}
            onChange={(checked) => handleUpdateVisibleItem(checked)}
          />
          Выводить в списке шаблонов
        </Space>
      )}
    </Flex>
  );
};

export default InfoSection;
